import { O as OramaButton$1, d as defineCustomElement$1 } from './p-1e863bca.js';
const OramaButton = OramaButton$1;
const defineCustomElement = defineCustomElement$1;
export { OramaButton, defineCustomElement }; //# sourceMappingURL=orama-button.js.map
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib3JhbWEtYnV0dG9uLmpzIiwic291cmNlcyI6W10sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiIifQ==